const React = require("react");
const PropTypes = require("prop-types");
const VerticalField = require("./vertical_field");

function OptionalVerticalField(props) {
  return props.value ? <VerticalField {...props} /> : null;
}

module.exports = OptionalVerticalField;
